<template>
  <div>
    <div v-if="showvitalspopup">
      {{ renderVitalsForm }}
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container" style="padding: 0">
              <!-- <div class="modal-header"> -->
              <!-- <slot name="header"></slot> -->
              <!-- <button type="button" @click.prevent="$emit('cancelAction')" class="close" data-dismiss="modal" style="top:12px;">
                                    <i class="material-icons">close</i>
                                </button> -->
              <!-- </div> -->
              <div
                class="modal-header popup-header-colored popup-header-blue"
              >
              <div class="popup-title">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:18px;height:18px;"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
                Vitals
              </div>
                <button
                  type="button"
                  @click.prevent="$emit('cancelAction')"
                  class="close popup-close"
                  data-dismiss="modal"
                >
                  ×
                </button>
              </div>
              <div class="modal-body popup-body">
                <slot name="body">
                  <div v-if="loaderspinner || vitalJsAddEventListenerInProgress" class="appointmentlist-spinner">
                    <div
                      class="processing_popup full-spinner"
                      style="
                        visibility: visible;
                        top: -68px;
                        height: 100%;
                        z-index: 9999999999;
                      "
                    >
                      <!-- <div class="spinner cover-spin">
                        <div class="bounce1"></div>
                        <div class="bounce2"></div>
                        <div class="bounce3"></div>
                      </div> -->
                    </div>
                  </div>
                      <div class="report-vital-section">
                        <!-- <form id="div-renderform2OuterVitals">
                          <div id="div-rendervitalsform2"></div>
                          <div class="row">
                            <div class="col-md-12 col-sm-12 col-xs-12">
                              <div class="row right">
                                <div class="col-md-12">
                                  <div>
                                    <a href="javascript:void(0);" @click="viewVitalspopup" class="mt-2 pull-right" v-if="isVitalSaved">
                                      <img src="@/static/images/print-icon.png" alt="Print"/>
                                    </a>
                                  </div>
                                  <button
                                    type="button"
                                    @click.prevent="saveVitals"
                                    class="primary-btn ripple pull-right"
                                  >
                                    Save
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form> -->
                       <form id="div-renderform2OuterVitals" @submit.prevent>
                          <div class="update_info" v-if="Vitals_UpdatedDate && Vitals_UpdatedBy">
                            <span id="vitaluppdate">Updated by {{ Vitals_UpdatedBy }} on {{ loadvitalformatdatev2(Vitals_UpdatedDate) }}</span>
                          </div>

                          <!-- BP / HR / RR -->
                          <div class="row">
                                <div class="col-md-4 form-group field-min-blood-pressure">
                                  <label class="vital-label">Blood Pressure — Systolic (mmHg)</label>
                                  <input type="number" id="min-blood-pressure" name="min-blood-pressure"
                                    class="form-control" min="50" placeholder="Systolic"
                                    v-model="form['min-blood-pressure']" />
                                </div>
                                <div class="col-md-4 form-group field-max-blood-pressure">
                                  <label class="vital-label">Blood Pressure — Diastolic (mmHg)</label>
                                  <input type="number" id="max-blood-pressure" name="max-blood-pressure"
                                    class="form-control" min="25" placeholder="Diastolic"
                                    v-model="form['max-blood-pressure']" />
                                </div>
                            <div class="col-md-4 form-group field-heart-rate">
                              <label for="heart-rate" class="vital-label">Heart Rate / Pulse (bpm)</label>
                              <input type="number" id="heart-rate" name="heart-rate" class="form-control" min="10"
                                v-model="form['heart-rate']" />
                            </div>
                          </div>

                          <!-- O2 / Temperature -->
                          <div class="row">
                            <div class="col-md-4 form-group field-02-sat">
                              <label for="02-sat" class="vital-label">O₂ Sat / SpO₂ (%)</label>
                              <input type="number" id="02-sat" name="02-sat" class="form-control" min="0"
                                v-model="form['02-sat']" />
                            </div>
                            <div class="col-md-4">
                              <div class="row">
                              <div class="col-md-8 form-group field-temperature">
                                <label for="temperature" class="vital-label">Temperature</label>
                                <input type="number" id="temperature" name="temperature" class="form-control" min="0"
                                  v-model="form['temperature']" />
                              </div>
                              <div class="col-md-4 form-group field-temperature-unit">
                                <label for="temperature-unit" class="vital-label">Unit</label>
                                <select id="temperature-unit" name="temperature-unit" class="form-control"
                                  v-model="form['temperature-unit']">
                                  <option value="F">F</option>
                                  <option value="C">C</option>
                                </select>
                              </div>
                            </div>
                            </div>
                            <div class="col-md-4 form-group field-respiratory-rate">
                              <label for="respiratory-rate" class="vital-label">Respiratory Rate (/min)</label>
                              <input type="number" id="respiratory-rate" name="respiratory-rate" class="form-control"
                                min="10" v-model="form['respiratory-rate']" />
                            </div>
                          </div>

                          <!-- Height / Weight -->
                          <div class="popup-bg">
                            <div class="popup-bg-title">Anthropometry &amp; BMI</div>
                            <div class="row">
                              <div class="col-md-4">
                                <div class="row">
                              <div class="col-md-8 form-group field-height-value">
                                <label for="height-value" class="vital-label">Height</label>
                                <input type="number" id="height-value" name="height-value" class="form-control" min="0"
                                  step="0.1" v-model="form['height-value']" @input="calculateBMI"/>
                              </div>
                              <div class="col-md-4 form-group field-height-unit-selected">
                                <label for="height-unit-selected" class="vital-label">Unit</label>
                                <select id="height-unit-selected" name="height-unit-selected" class="form-control"
                                  v-model="form['height-unit-selected']">
                                  <option value="ft">ft</option>
                                  <option value="cm">cm</option>
                                </select>
                              </div>
                              </div>
                              </div>
                              <div class="col-md-4">
                                <div class="row">
                              <div class="col-md-8 form-group field-weight-value">
                                <label for="weight-value" class="vital-label">Weight</label>
                                <input type="number" id="weight-value" name="weight-value" class="form-control" min="0"
                                  step="0.1" v-model="form['weight-value']" @input="calculateBMI"/>
                              </div>
                              <div class="col-md-4 form-group field-weight-unit-selected">
                                <label for="weight-unit-selected" class="vital-label">Unit</label>
                                <select id="weight-unit-selected" name="weight-unit-selected" class="form-control"
                                  v-model="form['weight-unit-selected']">
                                  <option value="kg">kg</option>
                                  <option value="lb">lb</option>
                                </select>
                              </div>
                              </div>
                              </div>
                              <div class="col-md-4 form-group field-calculated-bmi-value">
                                <label for="calculated-bmi-value" class="vital-label">BMI Calculated</label>
                                <input type="number" id="calculated-bmi-value" name="calculated-bmi-value"
                                  class="form-control" min="0" step="0.01" v-model="form['calculated-bmi-value']" readonly/>
                              </div>
                            </div>

                          <!-- BMI -->
                          <div class="row" hidden>
                            <div class="col-md-5 form-group field-calculate-bmi-button" style="margin-bottom:0;">
                              <button type="button" id="calculate-bmi-button" name="calculate-bmi-button"
                                class="md-button md-raised md-primary md-theme-default btn btn-primary"
                                @click.prevent="calculateBMI">
                                <b>Calculate BMI</b>
                              </button>
                            </div>
                          </div>
                          </div>

                          <!-- Doctor's summary -->
                          <div class="row">
                            <div class="col-md-12 form-group field-textarea-1543496414210">
                              <label for="textarea-1543496414210" class="vital-label">Doctor's Summary</label>
                              <textarea id="textarea-1543496414210" name="textarea-1543496414210" ref="doctorSummary"
                                class="form-control" rows="3" v-model="form['textarea-1543496414210']"></textarea>
                            </div>
                          </div>

                          <!-- Pregnant + actions -->
                          <div class="row">
                            <div class="col-md-12">
                              <div class="row right">
                                <div class="col-md-12">
                                  <div v-if="Gender != 'male' || Gender != 'Male'"
                                      class="col-md-6 formbuilder-radio-group form-group field-radio-group-1546595623086">
                                      <label class="vital-label" style="margin-right:8px;">Is pregnant?</label>
                                      <label class="radio-inline">
                                        <input type="radio" name="radio-group-1546595623086"
                                          id="radio-group-1546595623086-0" value="Yes"
                                          v-model="form['radio-group-1546595623086']" /> Yes
                                      </label>
                                      <label class="radio-inline">
                                        <input type="radio" name="radio-group-1546595623086"
                                          id="radio-group-1546595623086-1" value="No"
                                          v-model="form['radio-group-1546595623086']" /> No
                                      </label>
                                    </div>
                                  <div class="pull-right" style="display:flex;align-items:center;gap:12px;">
                                    <button type="button" @click.prevent="saveVitals"
                                      class="primary-btn ripple">Save</button>

                                    <a href="javascript:void(0);" @click="viewVitalspopup" v-if="isVitalSaved">
                                      <img src="@/static/images/print-icon.png" alt="Print" />
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <vitalsprintpopup
      ref="vitalsPopUpRefModal"
      :vitalsobj="vitalspopObj"
    ></vitalsprintpopup>
  </div>
</template>

<script>
import rest_service from "@/api/rest_service";
import Axios from "axios";
import vitalsjs from "@/common/vitals";
import { uuid } from "vue-uuid";
import moment from "moment";
export default {
  name: "vitals-popup",
  props: [
    "showvitalspopup",
    "encounterid",
    "vitalsformjson",
    "parentobj",
    "encounterdata",
    "Vitals_UpdatedDate",
    "Vitals_UpdatedBy",
    "Gender",
  ],
  components: {
    vitalsprintpopup: () => import("@/components/Vitals/VitalsPrintpopup.vue"),
   },
  data() {
    return {
      uuid: uuid.v1(),
      loaderspinner: false,
      vitalJsAddEventListenerInProgress: true,
      isVitalSaved:false,
      vitalspopObj: {},
      providerData:null,
      form: this.defaultForm(), 
    };
  },
  created() {},
  mounted() {},
  watch: {
    showvitalspopup() { this.initForm(); },
    vitalsformjson: { handler() { this.initForm(); }, immediate: true },
  },
  methods: {
    defaultForm() {
      return {
        "height-value": "",
        "height-unit-selected": "ft",
        "weight-value": "",
        "weight-unit-selected": "kg",
        "calculated-bmi-value": "",
        "min-blood-pressure": "",
        "max-blood-pressure": "",
        "heart-rate": "",
        "respiratory-rate": "",
        "02-sat": "",
        "temperature": "",
        "temperature-unit": "F",
        "textarea-1543496414210": "",
        "radio-group-1546595623086": "No",
      };
    },

    // Accepts the plain field array OR the [{ whichPatient, Vitals }] wrapper
    getVitalFields(json) {
      if (typeof json === "string" && json) json = JSON.parse(json);
      if (!Array.isArray(json)) return [];
      if (json.some((x) => x && x.whichPatient !== undefined)) {
        const op = json.find((x) => x.whichPatient === "outpatient");
        return op && Array.isArray(op.Vitals) ? op.Vitals : [];
      }
      return json;
    },

    // Returns the saved value for one field, or undefined if nothing is saved
    getSavedValue(f) {
      let val = f.value;
      if ((val === undefined || val === null || val === "") && Array.isArray(f.userData) && f.userData.length) {
        val = f.userData[0];
      }
      if (Array.isArray(f.values)) {               // select / radio-group
        const match = f.values.find((v) => String(v.value) === String(val));
        if (match) return match.value;
        const sel = f.values.find((v) => v.selected);
        return sel ? sel.value : undefined;
      }
      return val === undefined || val === null || val === "" ? undefined : val;
    },

    initForm() {
      debugger;
      if (!this.vitalsformjson || !this.showvitalspopup) return;
      this.loaderspinner = true;

      let fields = this.getVitalFields(this.vitalsformjson);
      fields = vitalsjs.renderVitalJson(fields) || fields;

      // defaults first, then overlay the most recent saved values
      const form = this.defaultForm();
      fields.forEach((f) => {
        if (!f || !f.name || !(f.name in form)) return;
        const saved = this.getSavedValue(f);
        if (saved !== undefined) form[f.name] = saved;
      });
      this.form = form;

      if ("isVitalSaved" in this.$parent) this.$parent.isVitalSaved = false;

      this.$nextTick(() => {
        this.$parent.textareacollection = this.$refs.quicknoteDoc_Summary_txt
          ? [this.$refs.quicknoteDoc_Summary_txt]
          : [];
        this.loaderspinner = false;
      });
    },

    calculateBMI() {
      const h = parseFloat(this.form["height-value"]);
      const w = parseFloat(this.form["weight-value"]);
      if (!h || !w) return;
      const cm = this.form["height-unit-selected"] === "ft" ? h * 30.48 : h;
      const kg = this.form["weight-unit-selected"] === "lb" ? w * 0.453592 : w;
      const m = cm / 100;
      this.form["calculated-bmi-value"] = (kg / (m * m)).toFixed(2);
    },
    loadvitalformatdatev2(vdate) {
      return (
        moment(vdate).format("DD/MM/YYYY") +
        " at " +
        moment(vdate).format("HH:mm")
      );
    },
    renderVitalJson(json) {
      if ($("#div-rendervitalsform2")) {
        let masterFormData = [];
        if (typeof json === "string" && json) {
          masterFormData = JSON.parse(json);
        } else {
          masterFormData = json;
        }
        masterFormData = vitalsjs.renderVitalJson(masterFormData);

        let formrenderinstance = $("#div-rendervitalsform2").formRender({
          formData: masterFormData,
          controlConfig: {
            "textarea.tinymce": {
              toolbar:
                "undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image| quicktable image | table | fontselect",
              font_formats:
                "Times New Roman=times new roman; Arial=arial; Calibri=calibri",
            },
          },
        });
        let $bmiButton = $("#calculate-bmi-button");
        if ($bmiButton.length) {
          $bmiButton.html("Calculate BMI"); // or the rich-HTML label if you want the styling
        }
        // if (
        //   $("#div-rendervitalsform2") &&
        //   this.Vitals_UpdatedDate != undefined && this.Vitals_UpdatedDate != null && this.Vitals_UpdatedDate != ""  && this.Vitals_UpdatedBy != undefined && this.Vitals_UpdatedBy != "" && this.Vitals_UpdatedBy != null
        // ) {
        //   $("#div-rendervitalsform2 h3").after(
        //     "<div class='update_info'><span id='vitaluppdate' class=''>Updated by " + this.Vitals_UpdatedBy+ " on "+
        //       this.Vitals_UpdatedDate +
        //       "</span></div>"
        //   );
        // }
        if ("isVitalSaved" in this.$parent) {
          this.$parent.isVitalSaved = false;
        }
        let interValrespovitalstxtarea = setTimeout(() => {
          let a = document.querySelectorAll('*[id^="textarea-"]');
          this.$parent.textareacollection = [];
          if (a) {
            a.forEach((y) => {
              if (y && y.getAttribute("id") === "textarea-1543496414210") {
                this.$parent.textareacollection.push(y);
                if (tinymce && y.id in tinyMCE.editors) {
                  tinyMCE.editors[y.id].setContent(y.value);
                  clearTimeout(interValrespovitalstxtarea);
                }
              }
            });
          }
        }, 1);
        this.loaderspinner = false;
        if (this.Gender == "male" || this.Gender == "Male") {
          $(".field-radio-group-1546595623086").css("display", "none");
        }
      }
    },
    saveVitals() {
      debugger;
      if (!vitalsjs.Checkcondtion()) {
        return false;
      }
      var fbRender = document.getElementById("div-renderform2OuterVitals");
      this.$parent.originalFormData = "";
      var tempCurrentData = {};
      if (this.vitalsformjson) {
        if (typeof this.vitalsformjson === "string") {
          this.$parent.originalFormData = JSON.parse(this.vitalsformjson);
          tempCurrentData = JSON.parse(this.vitalsformjson);
        } else {
          this.$parent.originalFormData = this.vitalsformjson;
          tempCurrentData = this.vitalsformjson;
        }
      }

      // assign outpatient arrray
      // for(let i=0; i<tempCurrentData.length; i++){
      //     if(tempCurrentData[i].whichPatient == "outpatient"){
      //         this.$parent.originalFormData = tempCurrentData[i].Vitals
      //     }
      //     else{
      //         this.$parent.originalFormData = tempCurrentData;
      //     }
      //     break;
      // }

      let formData = new FormData(fbRender);
      if (
        this.$parent &&
        this.$parent.saveFormValues &&
        typeof this.$parent.saveFormValues === "function"
      ) {
        console.log(this.$parent);
        this.$parent.saveFormValues(formData, this.$parent.originalFormData);
      }

      //this.vitalsformjson = originalFormData;

      if (
        this.$parent &&
        this.$parent.encounter &&
        typeof this.$parent.encounter === "object"
      ) {
        console.log(this.$parent.encounter);
        //forcefully assign updated values to the doctor's sumamry
        this.$parent.originalFormData.forEach((y) => {
          if (
            y.name === "textarea-1543496414210" &&
            tinyMCE &&
            tinyMCE.editors &&
            tinyMCE.editors[y.name]
          ) {
            y.value = tinyMCE.editors[y.name].getContent();
          }
        });

        if (this.$parent.totalVitalForm) {
          console.log("--");
        }
        var check=false;
        if (!this.$parent.encounter.Vitals) {
          check=true;
          this.$parent.encounter.Vitals = [];
          var newVital = {};
          newVital["uuid"] = this.uuid;
          newVital["whichPatient"] = "outpatient";
          newVital["Vitals_CreatedDate"] = new Date().toISOString();
          newVital["Vitals"] = this.$parent.originalFormData;
          this.$parent.encounter.Vitals.push(newVital);
        } else {
          // Outer vitals key is present, so update the values
          var self = this;
          // for(let i=0; i<this.$parent.encounter.Vitals.length;i++){
          //     if (this.$parent.encounter.Vitals[i].whichPatient=="outpatient"){
          //         this.$parent.encounter.Vitals[i].Vitals = self.$parent.originalFormData;
          //         this.$parent.encounter.Vitals_CreatedDate = new Date().toISOString();
          //         break;
          //     }
          // }
          const found = this.$parent.encounter.Vitals.some(
            (el) => el.whichPatient === "outpatient"
          );

          if (!found) {
            var newVital = {};
            newVital["uuid"] = this.uuid;
            newVital["whichPatient"] = "outpatient";
            newVital["Vitals_CreatedDate"] = new Date().toISOString();
            newVital["Vitals"] = this.$parent.originalFormData;
            this.$parent.encounter.Vitals.push(newVital);
          } else {
            for (let i = 0; i < self.$parent.encounter.Vitals.length; i++) {
              if (
                this.$parent.encounter.Vitals[i].whichPatient == "outpatient"
              ) {
                this.$parent.encounter.Vitals[i].Vitals =
                  this.$parent.originalFormData; //"Modified when outpatient existed"
                this.$parent.encounter.Vitals[i].Vitals_CreatedDate =
                  new Date().toISOString();
                break;
              }
            }
          }
        }

        // this.$parent.encounter["Vitals"] = this.$parent.originalFormData;
        this.$parent.encounter["Vitals_UpdatedDate"] = new Date().toISOString();
        if (
          this.$parent.encounter["Vitals_UpdatedByID"] == null ||
          this.$parent.encounter["Vitals_UpdatedByID"] != ""
        )
          this.$parent.encounter.Vitals_UpdatedByID =
            this.$parent.role_unique_id;
        else
          this.$parent.encounter["Vitals_UpdatedByID"] =
            this.$parent.role_unique_id;
        if (
          this.$parent.encounter["Vitals_UpdatedBy"] == null ||
          this.$parent.encounter["Vitals_UpdatedBy"] != ""
        )
          this.$parent.encounter.Vitals_UpdatedBy = "";
        else this.$parent.encounter["Vitals_UpdatedBy"] = "";

        //this.$parent.encounter["modified_date"] = new Date().toISOString();
        //this.$parent.encounter.nameofspecialization=this.$parent.routematch;
        //this.$parent.encounter.categories=this.$parent.providercategories;
        //this.$parent.encounter.customer_id_appo_id_uniq_id = this.encounterid;
        this.$parent.encounterData = this.$parent.encounter;
      }

      this.loaderspinner = true;
      // if(this.$parent && this.$parent.saveFormValues2 && typeof this.$parent.saveFormValues2==="function"){
      //     this.$parent.saveFormValues2();
      // }
      if ("isVitalSaved" in this.$parent) {
        this.$parent.isVitalSaved = true;
        this.isVitalSaved=true;
      }
      if (
        this.$parent.quicknotes_selectedview === "Quick Notes" &&
        this.$parent.quicknote_Save &&
        typeof this.$parent.quicknote_Save === "function"
      ) {
        this.$parent.quicknote_Save();
      } else if (
        (this.$parent.quicknotes_selectedview === "Advanced Forms" ||
          this.$parent.quicknotes_selectedview === "SOAP Notes") &&
        this.$parent.saveFormValues2 &&
        typeof this.$parent.saveFormValues2 === "function"
      ) {
        this.$parent.saveFormValues2();
      } else if (
        this.$parent.quicknotes_selectedview === "Simple Notes" &&
        this.$parent.simplenote_Save &&
        typeof this.$parent.simplenote_Save === "function"
      ) {
        this.$parent.simplenote_Save();
      }
          if (this.$route.name === "QuickEHR") {
          this.$emit(
              "vitalsUpdated",
              JSON.parse(JSON.stringify(this.$parent.originalFormData))
          );
      }
      if(check==true)
      {
        setTimeout(() => {
          // this.vitalsformjson = JSON.parse(
          //   JSON.stringify(this.$parent.originalFormData)
          // );
          this.$parent.Reload();
        }, 3000);
       
      }
    },
    viewVitalspopup(){
      debugger
      var self = this;
      
        self.vitalspopObj = {};
        var temp_vitalspopObj = {};
        temp_vitalspopObj.businesssetup = {};
        temp_vitalspopObj.businesssetup.name =JSON.parse(localStorage.tenantbusinesssetup).name
        temp_vitalspopObj.businesssetup.location = {};
        temp_vitalspopObj.businesssetup.location.address =JSON.parse(localStorage.slctdappfacltaddr).location_name;
        temp_vitalspopObj.businessappintmenturl =
          localStorage.businessappintmenturl +
          "/book-appointment" +
          "/" +
          JSON.parse(localStorage.slctdappfacltaddr).unique_id +
          "/" +
          this.loggedin_user_unique_id;
        
        //vital json form parsed
        temp_vitalspopObj.vitals =
        this.$parent.originalFormData && this.$parent.originalFormData.length
          ? this.$parent.originalFormData
          : this.vitalsformjson;

        temp_vitalspopObj.modalencounterdate = self.$parent.Visit_time;
        temp_vitalspopObj.patientdetails = {};
        temp_vitalspopObj.staffDetails = JSON.parse(
          localStorage.loggedInUserInfo
        );
        let default_category = "";
        if (
          temp_vitalspopObj.staffDetails &&
          temp_vitalspopObj.staffDetails.specialization
        ) {
          temp_vitalspopObj.staffDetails.category =
            temp_vitalspopObj.staffDetails.specialization;
        }
       const src = self.$parent.selectedpatienttemp || self.$parent.patientdetails;

      temp_vitalspopObj.patientdetails = src.patient_details || src || {};
      temp_vitalspopObj.provider_id = src.provider_id || "";
  
        temp_vitalspopObj.footernote1 =
          self.providerData &&
          self.providerData.hasOwnProperty("FOOTER_NOTE1") &&
          self.providerData.FOOTER_NOTE1 &&
          self.iscustomform
            ? self.providerData.FOOTER_NOTE1
            : "";
        self.vitalspopObj = temp_vitalspopObj;
       
          var element = self.$refs.vitalsPopUpRefModal.$el;
          $(element).modal("show");
    }
  },
  computed: {
    renderVitalsForm() {
      debugger;
      if (this.vitalsformjson && this.showvitalspopup) {
        //extract outpatient vitals arr data
        // var VitalsArr = []
        // for(let i=0; i<this.vitalsformjson.length; i++){
        //     if(this.vitalsformjson[i].whichPatient=="outpatient"){
        //         VitalsArr = this.vitalsformjson[i].Vitals;
        //     }
        //     else{
        //         // VitalsArr = this.vitalsformjson;

        //         var parms = {
        //             form_code: "Vitals",
        //         };
        //         rest_service
        //         .get("/formbuilder/getformbyid", localStorage.tenantid, parms)
        //         .then((respo) => {
        //             if (respo.data && respo.data.result) {
        //             // self.vitalForm =
        //             VitalsArr =  respo.data.result.jsonData;
        //             // self.totalVitalForm = self.vitalForm;
        //             // self.vitalsformjson = self.vitalForm;
        //             }
        //         })
        //         .finally(() => {
        //             // this.isvitalprocessing = false;
        //         });
        //     }
        //     break;
        // }
        this.loaderspinner = true;
        setTimeout(() => {
          this.renderVitalJson(this.vitalsformjson);
        }, 1);
        if ("isVitalSaved" in this.$parent) {
          this.$parent.isVitalSaved = false;
        }
      }
    },
  },
  updated() {
    vitalsjs.addEventListeners();
    this.vitalJsAddEventListenerInProgress = false;
  },
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  position: fixed;
  top: 10px;
  bottom: 10px;
  width: 100%;
  overflow-y: auto;
}

.modal-container {
  width: 800px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin-top: 10px 0;
  margin-right: 20px 0;
  margin-bottom: 20px 0;
  margin-left: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-container.modal-width500 {
  max-width: 500px;
  width: 500px;
  padding: 10px;
}
.modal-container.modal-width500 .modal-header {
  border-bottom: 1px solid transparent !important;
  padding-bottom: 0px !important;
}
.modal-container.modal-width500 .modal-footer {
  border-top: 1px solid transparent !important;
}
.modal-container.modal-width500 .modal-header {
  min-height: 10px !important;
}
.modal-container.modal-width500 .modal-body {
  margin: 0px !important;
}
.hidden-field {
  display: none;
}
.vital-label {
  font-size: 10.5px;
  font-weight: 800;
  color: #64748B;
  text-transform: uppercase;
  letter-spacing: 0.7px;
  margin-bottom: 7px;
  width: auto !important;
}

.popup-header-colored {
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}
.popup-header-blue {
	background: linear-gradient(135deg, #0056D2 0%, #1273EB 100%);
}
.popup-title{
  color: #fff;
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  font-weight: 700;
}
.popup-header-colored .popup-close {
	color: rgba(255,255,255,0.9);
  font-size: 22px;
  background: rgba(255,255,255,0.12);
  border: 1px solid rgba(255,255,255,0.2);
  border-radius: 6px;
  padding: 4px 10px;
  cursor: pointer;
  line-height: 1;
  -webkit-transition: background 0.15s;
  transition: background 0.15s;
  font-weight: normal;
  margin: 0;
  text-shadow: none;
}
.av2-input {
	width: 100%;
	border: 1.5px solid #E2E8F0;
	border-radius: 9px;
	background: #fff;
	padding: 11px 13px;
	font-family: 'Inter', sans-serif;
	font-size: 15px;
	font-weight: 600;
	color: #0F172A;
	outline: none;
	transition: border-color 0.15s, box-shadow 0.15s;
}
.popup-body {
 margin:0; 
}
.popup-body .report-vital-section{
  margin: 0;
  float: none;
  top: 0;
}
.popup-body .report-vital-section input, .popup-body .report-vital-section select, textarea.form-control {
	margin-bottom: 0;
	width: 100%;
	border: 1.5px solid #E2E8F0 !important;
	border-radius: 9px !important;
	background: #fff;
	padding: 11px 13px;
	font-family: 'Inter', sans-serif;
	font-size: 15px !important;
	font-weight: 600 !important;
	color: #0F172A !important;
	outline: none;
	transition: border-color 0.15s, box-shadow 0.15s;
}
.popup-body .report-vital-section input:focus {
	border-color: var(--brand-blue);
	box-shadow: 0 0 0 3px rgba(18,115,235,0.10);
}
.popup-body .report-vital-section select{
  appearance: auto;
  padding: 6px 10px;
}
.popup-body .row .row .col-md-4 {
  padding-left: 0;
}
.popup-bg{
  background: #F1F5F9;
  border-radius: 12px;
  padding: 16px 18px;
  margin-bottom: 15px;
}
.popup-bg-title {
  font-size: 11px;
  font-weight: 800;
  color: #94A3B8;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 13px;
}
.popup-body .formbuilder-radio-group{
  margin: 0;
}
.popup-body .formbuilder-radio-group label {
	margin: 0 12px 0 0;
}
.popup-body .formbuilder-radio-group input {
	width: auto !important;
} 
.report-vital-section .ripple {
	border-radius: 9px;
}
.popup-body .update_info {
	margin-bottom: 20px;
	text-align: right;
	color: #64748B;
}
</style>